/**
 * Ploufe — helpcentrum (sections/lan-faq.liquid): routing tussen de
 * kaarten-weergave en de onderwerppagina's (URL-hash #onderwerp=<slug>,
 * werkt met de browser-terugknop via hashchange), het accordeon per
 * onderwerp, en de live client-side zoekfunctie.
 *
 * De initiële weergave (bij het direct openen van een gedeelde
 * onderwerp-link) is al gezet door het blokkerende inline scriptje in
 * sections/lan-faq.liquid, vóórdat dit bestand (defer) laadt — dit
 * bestand neemt het daarna over voor alle volgende navigatie.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var HASH_RE = /onderwerp=([^&]+)/;
  var MAX_RESULTS = 6;

  function initFaq(root) {
    var home = root.querySelector('[data-faq-home]');
    var topics = Array.prototype.slice.call(root.querySelectorAll('[data-faq-topic]'));
    var backLinks = Array.prototype.slice.call(root.querySelectorAll('[data-faq-back]'));
    var searchInput = root.querySelector('[data-faq-search-input]');
    var searchResults = root.querySelector('[data-faq-search-results]');
    var dataScript = root.querySelector('[data-faq-data]');

    if (!home || !topics.length) return;

    // ------------------------------------------------------------------
    // Routing
    // ------------------------------------------------------------------
    function slugFromHash() {
      var m = HASH_RE.exec(location.hash);
      return m ? decodeURIComponent(m[1]) : null;
    }

    function showTopic(slug) {
      var found = false;
      topics.forEach(function (topic) {
        var match = topic.getAttribute('data-slug') === slug;
        topic.hidden = !match;
        if (match) found = true;
      });
      if (found) {
        home.hidden = true;
      } else {
        home.hidden = false;
        topics.forEach(function (topic) {
          topic.hidden = true;
        });
      }
      return found;
    }

    function showHome() {
      home.hidden = false;
      topics.forEach(function (topic) {
        topic.hidden = true;
      });
    }

    function applyRoute() {
      var slug = slugFromHash();
      if (slug) {
        showTopic(slug);
      } else {
        showHome();
      }
    }

    // Alleen op eigen "onderwerp="-hashes reageren — #lan-faq-contact (de
    // "neem contact op"-links) is een gewoon in-page anker en moet gewoon
    // native scrollen, niet door de router worden opgevangen.
    window.addEventListener('hashchange', function () {
      if (!HASH_RE.test(location.hash) && location.hash !== '') return;
      applyRoute();
    });

    backLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        history.pushState(null, '', location.pathname + location.search);
        showHome();
        home.scrollIntoView({ block: 'start' });
      });
    });

    // Initiële staat: als het blokkerende inline scriptje al een onderwerp
    // heeft getoond, hier niets dubbel doen — anders (geen hash, of een
    // hash zonder match) normaal toepassen.
    if (!window.__lanFaqInitialTopic) {
      applyRoute();
    }

    // ------------------------------------------------------------------
    // Accordeon
    // ------------------------------------------------------------------
    function setPanelHeight(panel, open) {
      if (open) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    }

    function openQuestion(questionEl) {
      var trigger = questionEl.querySelector('[data-faq-trigger]');
      var panel = questionEl.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      setPanelHeight(panel, true);
    }

    function closeQuestion(questionEl) {
      var trigger = questionEl.querySelector('[data-faq-trigger]');
      var panel = questionEl.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;
      trigger.setAttribute('aria-expanded', 'false');
      setPanelHeight(panel, false);
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-faq-trigger]') : null;
      if (!trigger) return;
      var questionEl = trigger.closest('[data-faq-question]');
      if (!questionEl) return;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeQuestion(questionEl);
      else openQuestion(questionEl);
    });

    // Hoogte van open panelen herberekenen bij resize (tekst kan
    // herbreken, bv. rotatie/breedte-wijziging op mobiel).
    window.addEventListener(
      'resize',
      function () {
        root.querySelectorAll('[data-faq-trigger][aria-expanded="true"]').forEach(function (trigger) {
          var panel = trigger.closest('[data-faq-question]').querySelector('[data-faq-panel]');
          if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      },
      { passive: true }
    );

    function openQuestionById(id) {
      var questionEl = root.querySelector('#' + CSS.escape(id));
      if (!questionEl) return null;
      openQuestion(questionEl);
      return questionEl;
    }

    function goToQuestion(slug, id) {
      location.hash = 'onderwerp=' + encodeURIComponent(slug);
      showTopic(slug);
      window.requestAnimationFrame(function () {
        var questionEl = openQuestionById(id);
        if (questionEl) {
          questionEl.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });
    }

    // ------------------------------------------------------------------
    // Zoeken
    // ------------------------------------------------------------------
    if (!searchInput || !searchResults || !dataScript) return;

    var index = [];
    try {
      var raw = JSON.parse(dataScript.textContent);
      raw.forEach(function (topic) {
        // Onderwerp-titel + subtekst tellen ook mee als zoektekst voor elke
        // vraag eronder: iemand die "levertijd" typt vindt zo de
        // leveringsvragen ook als dat woord alleen in de subtekst van het
        // onderwerp staat ("Levertijd, updates en bezorging"), niet
        // noodzakelijk letterlijk in een vraag/antwoord zelf.
        var topicContext = ((topic.title || '') + ' ' + (topic.subtext || '')).toLowerCase();
        topic.questions.forEach(function (q) {
          index.push({
            topicTitle: topic.title,
            topicSlug: topic.slug,
            topicContext: topicContext,
            question: q.question,
            answer: q.answer,
            id: q.id
          });
        });
      });
    } catch (e) {
      index = [];
    }

    var activeIndex = -1;
    var currentMatches = [];

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    function search(term) {
      var needle = term.trim().toLowerCase();
      if (!needle) return [];
      return index
        .filter(function (item) {
          return (
            item.question.toLowerCase().indexOf(needle) !== -1 ||
            item.answer.toLowerCase().indexOf(needle) !== -1 ||
            item.topicContext.indexOf(needle) !== -1
          );
        })
        .slice(0, MAX_RESULTS);
    }

    function renderResults(matches) {
      currentMatches = matches;
      activeIndex = -1;
      searchResults.innerHTML = '';

      if (!matches.length) {
        var empty = document.createElement('p');
        empty.className = 'lan-faq__search-empty';
        empty.textContent = 'Geen vraag gevonden. Stel hem via het formulier hieronder.';
        searchResults.appendChild(empty);
        searchResults.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
        return;
      }

      matches.forEach(function (item, i) {
        var a = document.createElement('a');
        a.href = '#onderwerp=' + encodeURIComponent(item.topicSlug);
        a.className = 'lan-faq__search-result';
        a.id = 'lan-faq-result-' + i;
        a.setAttribute('role', 'option');
        a.innerHTML =
          '<span class="lan-faq__search-result-topic">' +
          escapeHtml(item.topicTitle) +
          '</span><span class="lan-faq__search-result-question">' +
          escapeHtml(item.question) +
          '</span>';
        a.addEventListener('click', function (event) {
          event.preventDefault();
          closeResults();
          goToQuestion(item.topicSlug, item.id);
        });
        searchResults.appendChild(a);
      });

      searchResults.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
    }

    function closeResults() {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      currentMatches = [];
    }

    function setActive(i) {
      var options = searchResults.querySelectorAll('.lan-faq__search-result');
      Array.prototype.forEach.call(options, function (el) {
        el.classList.remove('is-active');
      });
      if (i >= 0 && options[i]) {
        options[i].classList.add('is-active');
        searchInput.setAttribute('aria-activedescendant', options[i].id);
        options[i].scrollIntoView({ block: 'nearest' });
      } else {
        searchInput.removeAttribute('aria-activedescendant');
      }
      activeIndex = i;
    }

    searchInput.addEventListener('input', function () {
      renderResults(search(searchInput.value));
    });

    searchInput.addEventListener('keydown', function (event) {
      if (searchResults.hidden && event.key !== 'Escape') return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!currentMatches.length) return;
        setActive(activeIndex + 1 >= currentMatches.length ? 0 : activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (!currentMatches.length) return;
        setActive(activeIndex - 1 < 0 ? currentMatches.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter') {
        if (!currentMatches.length) return;
        event.preventDefault();
        var item = activeIndex >= 0 ? currentMatches[activeIndex] : currentMatches[0];
        closeResults();
        goToQuestion(item.topicSlug, item.id);
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) return;
      if (event.target === searchInput || searchResults.contains(event.target)) return;
      closeResults();
    });
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-lan-faq]');
    roots.forEach ? roots.forEach(initFaq) : Array.prototype.forEach.call(roots, initFaq);
  });
})();
